import React from 'react';
import { FaStar } from 'react-icons/fa';
import { BsGrid3X3GapFill } from 'react-icons/bs';
import phoneMockup from './assets/mobile-img.png';
import starIcon from './assets/icons/start.svg';

import icon1 from './assets/icons/section2_icon1.svg'
import icon2 from './assets/icons/section2_icon2.svg'
import icon3 from './assets/icons/section2_icon3.svg'

const highlightedFeatures = [
    { icon: icon1, title: 'AI Smart Follow-Up Assistant', description: 'AI detects lead activity and auto-follows up via text/email (with quiet hour settings + on/off toggles).' },
    { icon: icon2, title: 'MLS Integrations', description: 'Access off-market listings, comps, and agent-only data (Phase 3).' },
];
const fullWidthFeature = {
    icon: icon3,
    title: 'Smart CRM Syncing',
    description: 'Auto-log your flyers, notes, CMAs, and buyer activity into your CRM.',
};
const gridFeatures = [
    { icon: icon3, title: 'Quarterly CMA', description: 'AI-generated reports and flyers sent to your past clients — on autopilot.' },
    { icon: icon3, title: 'Voice-to-Text Open House Mode', description: 'Record convos, and let AI generate clean, searchable notes.' },
    { icon: icon3, title: 'Disclosure Summary + Cost Estim...', description: 'Upload inspection and termite reports.' },
    { icon: icon3, title: 'Referral Marketplace', description: 'Send, track, and manage agent-to-agent referrals across the U.S.' },
    { icon: icon3, title: 'Full AI Marketing Suite (Desktop)', description: 'Plan full email campaigns, newsletters, and branded content in seconds.' },
    { icon: icon3, title: 'Full Web Dashboard', description: 'Send, track, and manage agent-to-agent referrals across the U.S.' },
];

const FeatureCard = ({ icon, title, description }) => (<div className="bg-white border-2 border-gray-100  rounded-2xl p-6  h-[9rem]"><div className="flex items-start gap-4"> <img src={icon} alt="" className="w-5 h-5 mt-1 flex-shrink-0" /><div><h4 className="font-semibold text-gray-800">{title}</h4><p className="mt-1 text-sm text-gray-500" style={{fontFamily: 'Inter, "Helvetica Neue", Helvetica, Arial, sans-serif' }}>{description}</p></div></div></div>);
const DashedFeatureCard = ({ icon, title, description }) => (
    <div className="border-2 border-gray-100 rounded-2xl p-6 h-full">
        <div className="flex items-start gap-4">
            <img src={icon} alt="" className="w-5 h-5 mt-1 flex-shrink-0" />
            <div>
                <h4 className="font-semibold text-gray-800">{title}</h4>
                <p className="mt-1 text-sm text-gray-500">{description}</p>
            </div>
        </div>
    </div>
);

const Section_2 = () => {
    return (
        <section id="section2" className="bg-white py-8 sm:pt-16">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                <div className="hidden lg:block">
                    <div className="grid grid-cols-12 gap-16 items-start">
                        <div className="col-span-5">
                            <img src={phoneMockup} alt="App sneak peek" className="w-full h-auto rounded-3xl" />
                        </div>

                        <div className="col-span-7">
                            <div className=" bg-[#F8F8F8] w-[12rem] p-[0.5rem]  rounded-3xl flex items-center text-sm font-semibold text-black-200 mb-2">

                                <img src={starIcon} alt="star" className="w-4 h-4 mr-2 inline-block" />
                                What's Coming Later

                            </div>
                            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight">
                                Here's a sneak peek of what's coming!
                            </h2>
                            <div className="mt-12 space-y-8">
                                <div className="grid grid-cols-2 gap-8">
                                    {highlightedFeatures.map((f, i) => <DashedFeatureCard key={i} {...f} />)}
                                </div>
                                <FeatureCard {...fullWidthFeature} />
                            </div>
                        </div>
                    </div>

                    <div className="mt-16 grid grid-cols-3 gap-8">
                        {gridFeatures.map((f, i) => <FeatureCard key={i} {...f} />)}
                    </div>
                </div>

                <div className="block lg:hidden">

                    <div className=" bg-[#F8F8F8]  w-[12rem] p-[0.5rem]  rounded-3xl  flex items-center text-sm font-semibold text-black-200 mb-2">
                        <img src={starIcon} alt="star" className="w-4 h-4 mr-2 inline-block" />  What's Coming Later
                    </div>
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight">
                        Here's a sneak peek of what's coming!
                    </h2>


                    <div className="mt-12">
                        <img src={phoneMockup} alt="App sneak peek" className="w-full max-w-sm mx-auto h-auto rounded-3xl" />
                    </div>


                    <div className="mt-12 space-y-8">

                        <div className="space-y-8">
                            {highlightedFeatures.map((f, i) => <DashedFeatureCard key={i} {...f} />)}
                        </div>


                        <FeatureCard {...fullWidthFeature} />

                        <div className="space-y-8">
                            {gridFeatures.map((f, i) => <FeatureCard key={i} {...f} />)}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Section_2;